import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { myModalStyles } from './MyModal.styles';

const MyModal = ({
  open = false,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'md',
  fullWidth = true,
  showCloseButton = true,
  disableBackdropClose = false,
  disableEscapeKeyDown = false,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = (event, reason) => {
    if (disableBackdropClose && reason === 'backdropClick') {
      return;
    }
    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return;
    }
    if (onClose) {
      onClose(event, reason);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={isMobile}
      disableRestoreFocus
      sx={myModalStyles.dialog}
      PaperProps={{
        sx: myModalStyles.paper(theme, isMobile),
      }}
      {...props}
    >
      {(title || showCloseButton) && (
        <DialogTitle sx={myModalStyles.title}>
          <Box sx={myModalStyles.titleContainer}>
            {title && (
              <Typography
                variant="h6"
                component="div"
                sx={myModalStyles.titleText}
              >
                {title}
              </Typography>
            )}
            {showCloseButton && (
              <IconButton
                onClick={event => handleClose(event, 'closeButtonClick')}
                sx={myModalStyles.closeButton}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>
        </DialogTitle>
      )}
      <DialogContent sx={myModalStyles.content}>{children}</DialogContent>
      {actions && (
        <DialogActions sx={myModalStyles.actions}>{actions}</DialogActions>
      )}
    </Dialog>
  );
};

export default MyModal;
